import * as React from 'react';
import { UIComponentState, UIComponentHandler } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { GenericTabViewModel, GenericTabViewModelImpl } from '../../../toolkit/tabs/generictabviewmodel';
import { GenericTabComponent } from '../../../toolkit/tabs/generictabcomponent';
import { WishlistComponentProps, WishlistTabComponentHandler, WishlistComponentHandler } from './wishlistcomponent';
import { WishlistCSSStyle } from './wishlistcss';
import { Strings } from '../../../../utils/resources/strings';
import { TabViewModelImpl } from '../../../toolkit/tabs/tab/tabviewmodel';
import { WishlistToneViewModelImpl } from './tones/wishlisttoneviewmodel';
import { PlaylistToneViewModelHandler } from './playlist/playlistcard/playlistviewmodel';
import { ToneDto } from '../../../../core/dto/tonedto';
import { CRBTUIViewImpl } from '../crbt/crbtuiview';
import { ToneRowOptionsPrivilageImpl } from '../../../toolkit/toneoptions/tone/tonerowcomponent';
import { WishListTabViewModelImpl } from './wishlisttabviewmodel';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { AlertType } from '../../../toolkit/alert/alerttype';
import { AlertComponent } from '../../../toolkit/alert/alertcomponent';
import { LoaderWrapperComponent } from '../../popup/loaderwrappercomponent';
import { LoaderComponent } from '../../../toolkit/loader/loadercomponent';
import { RoutingFeatures } from '../../navigation/routingfeature';

import './wishlist-style.css';

export class WishlistPlaylistOptionPrivilageImpl extends ToneRowOptionsPrivilageImpl
{
 

    constructor()
    {
        super();

        this.setTellAFriend(true);
        this.setGift(true);
        this.setShare(true);
        this.setBuy(true);
        this.setAction(true);
    }
   
}

export class WishlistViewImpl extends CRBTUIViewImpl implements WishlistTabComponentHandler, PlaylistToneViewModelHandler
{
    private genericTabViewModel: GenericTabViewModel;
    private tonesTab: TabViewModelImpl;
    private popupComponent:PopUpWrapperComponent ;
    private loaderWrapperComponent:LoaderWrapperComponent;
    // private playlistTab: TabViewModelImpl;

    constructor(basecontext: BaseContext, uiComponentHandler: UIComponentHandler)
    {
        super(basecontext, uiComponentHandler);

        this.onDelete = this.onDelete.bind(this);
        this.genericTabViewModel = new GenericTabViewModelImpl();
        this.tonesTab = new WishListTabViewModelImpl(basecontext,
            basecontext.getResources().getString(Strings.tunes), 
            new WishlistToneViewModelImpl(basecontext, "40px", this.onDelete));

        // this.playlistTab = new PlayListTabViewModelImpl(basecontext, 
        //     basecontext.getResources().getString(Strings.playlist), 
        //     new PlaylistToneViewModelImpl(offset, basecontext,{}, {},new WishlistPlaylistOptionPrivilageImpl(),
        //      this));

        this.genericTabViewModel.addTab(this.tonesTab);
        // this.genericTabViewModel.addTab(this.playlistTab);
    }
    bindHandlers()
    {
        this.showPopup = this.showPopup.bind(this);
        this.closePopup = this.closePopup.bind(this);
        this.showLoader = this.showLoader.bind(this);
        this.dismissLoader = this.dismissLoader.bind(this);
        this.confirmClick  = this.confirmClick.bind(this);
    }
    
    getChildComponent(props: WishlistComponentProps, state: UIComponentState, cssStyle: WishlistCSSStyle): JSX.Element
    {
        return (
            <>
            {
                                this.getWebView(props, state, cssStyle)
                            }
            {/* <div id="wishlist-info-web">
                            {
                                this.getWebView(props, state, cssStyle)
                            }
                   </div>
                   <div id="wishlist-info-mobile">
                            {
                                this.getMobileView(props, state, cssStyle)
                            }
                   </div> */}
                   <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={props.context}/>
        <LoaderWrapperComponent ref={(item: any) => this.loaderWrapperComponent = item} context={props.context}/>
            </>
        );
    }

    getWebView(props: WishlistComponentProps, state: UIComponentState, cssStyle: WishlistCSSStyle)
    {
        return (
            <div style={cssStyle.getWrapperCSSStyle()}>
              <GenericTabComponent onTabSelected={()=>{}}headerTitle={props.context.getResources().getString(Strings.my_wishlist)} initialTab={props.context.getResources().getString(Strings.tunes)} genericTabViewModel={this.genericTabViewModel} context={props.context}/>
            
          </div>
        );
    }

    getNavigationPath()
    {
        return [this.getUIProps().context.getResources().getString(Strings.myaccount),
             this.getUIProps().context.getResources().getString(Strings.wishlist)];
    }

    getBannerImg()
    {
        return "wishlist.jpg";
    }

    updateTonesData(tonedto: ToneDto[])
    {
        (this.tonesTab as WishListTabViewModelImpl).updateTabData(tonedto);
    }

    // updatePlaylistData(tonedto: ToneDto[])
    // {
    //     (this.playlistTab as PlayListTabViewModelImpl).updateTabData(tonedto);
    // }
    onDelete(tonedto: ToneDto)
    {
        (this.tonesTab as WishListTabViewModelImpl).deleteData(tonedto.getId());
    }

    showLoader()
    {
       
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(true,  <LoaderComponent context={this.getUIProps().context}/>);   
    }
  
    dismissLoader()
    { 
        this.loaderWrapperComponent !== null && this.loaderWrapperComponent.setShowWindow(false, <></>);
    }
    showPopup(msg: string, type: AlertType,title:string)
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true, <AlertComponent buttonTitle={title} alertMessage={msg} alertType={type} onCloseButtonClick={this.confirmClick} onClick={this.confirmClick} context={this.getUIProps().context}/>);
    }
    
    closePopup()
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }
    onLoadMore(startIndex: number, offset: number, searchKey: string): void 
    {
       (this.getUIComponentHandler() as WishlistComponentHandler).onLoadMore(this.genericTabViewModel.getSelectedTabTitle(), 
       startIndex, offset, searchKey);
    }
    confirmClick()
    {
        this.dismissLoader();
        this.getUIProps().context.getRedirectionHandler().routeNextFeature(RoutingFeatures.HOME, false);
    }
    onPlaylistSelected(playlistdto: ToneDto): void 
    {
        (this.getUIComponentHandler() as WishlistComponentHandler).onPlaylistSelected(playlistdto);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/wishlist/wishlistview.tsx